<template lang="html">
    <div>
        <header>
            <div class="navbar-fixed">
                <nav class="header-color">
                    <a @click="$emit('push-route', { url: 'CompetitionDashboard', solo: false })" class="brand-logo-supplier">
                        <img src="@/assets/images/engelink_logo.svg" class="center-element" alt="Engelink" />
                    </a>
                    <div class="supplier-data">
                            <a class="link-menu"
                                id="new" 
                                @click="$emit('push-route', { url: 'https://salesfeed.ai/', solo: true })"> 
                                <span> Inteligência Artificial </span>
                            </a>
                            <a class="link-menu" 
                                @click="$emit('set-supplier')" 
                                style="color: #0173cd">
                                <span> Engelink Crédito </span>
                            </a>
                            <a class="link-menu" @click="$emit('push-route', { url: 'https://condo.news/', solo: true })">
                                <span> CondoNews </span>
                            </a>
                            <a class="link-menu" @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })">
                                <span> Engelink Materiais </span>
                            </a>
                        <div 
                            v-show="useCreditCardCountdown != 0" 
                            class="bonus-info" 
                            :content="useCreditCardCountdownText"
                            v-tippy="{placement : 'bottom',  arrow: true}"
                        >
                            <div class="countdown-title">
                                Próxima compra em
                            </div>
                            <div class="countdown-value">
                                <countdown :time="useCreditCardCountdown" @end="onUseCreditCardCountdownEnd">
                                    <template slot-scope="props">
                                        {{ numberWithPaddingZeros(props.hours) }}:
                                        {{ numberWithPaddingZeros(props.minutes) }}:
                                        {{ numberWithPaddingZeros(props.seconds) }}
                                    </template>
                                </countdown>
                            </div>
                        </div>
                        <div v-show="bonus != '0'" class="bonus-info">
                            <div class="bonus-title">
                                Bônus
                            </div>
                            <div class="bonus-value">{{ convertNumberToBRLLocal(bonus) }}</div>
                        </div>
                        <div v-show="coins != '0'" class="coins-info">
                            <div class="coins-title">
                                Moedas
                                <div class="coins-value">{{ convertNumberToBRLLocal(coins) }}</div>
                            </div>
                        </div>
                        <div class="supplier-info">
                            <div class="supplier-title">
                                {{ supplierName }}
                                <div v-show="planType.length" class="plan-title">{{ planType }}</div>
                            </div>
                            <div class="btn-dropdown">
                                <span v-if="userNotification > 0" class="notification-circle"></span>
                                <button @click="show = !show" class="btn-hat btn-floating waves-effect waves-light">
                                    <i class="icon-hard-hat fas fa-hard-hat"></i>
                                </button>
                            </div>
                        </div>
                        <transition name="translate-fade-down">
                            <div v-show="show" class="dropdown-content-supplier">
                                <li
                                    class="dropdown-item notification-item"
                                    @click="$emit('showModal');show = !show"
                                >
                                    <span>Notificações</span>
                                    <span v-if="userNotification > 0" class="notification-count">{{userNotification}}</span>
                                </li>
                                <li
                                    class="dropdown-item"
                                    @click="
                                        $emit('push-route', { url: 'BalancePurchase', solo: false });
                                        show = !show;
                                    "
                                >
                                    Pacote de Moedas
                                </li>
                                <li
                                    class="dropdown-item"
                                    @click="
                                        $emit('push-route', { url: 'ContactUs', solo: false });
                                        show = !show;
                                    "
                                >
                                    Fale Conosco
                                </li>
                                <li
                                    v-show="!planType.length"
                                    class="dropdown-item"
                                    @click="
                                        $emit('openSubscriptionAlertModal');
                                        show = !show;
                                    "
                                >
                                    Planos
                                </li>
                                <li
                                    class="dropdown-item"
                                    @click="
                                        $emit('push-route', { url: 'EditProfileSupplier', solo: false });
                                        show = !show;
                                    "
                                >
                                    Editar perfil
                                </li>
                                <li
                                    class="dropdown-item"
                                    @click="
                                        $emit('push-route', { url: 'Home', solo: false, query: { redirect: false } });
                                        show = !show;
                                    "
                                >
                                    Alterar Perfil
                                </li>
                                <li
                                    class="dropdown-item"
                                    @click="
                                        $emit('logout');
                                        show = !show;
                                    "
                                    href="#"
                                >
                                    Sair
                                </li>
                            </div>
                        </transition>
                    </div>
                </nav>
            </div>
        </header>
    </div>
</template>

<script>
import { numberWithPaddingZeros } from '@/utils/filters';

import { mapActions } from 'vuex';

export default {
    name: 'HeaderSupplierDesktop',
    data: () => ({
        show: false,
        useCreditCardCountdownText: 'Tempo restante para sua próxima participação em cotações.'
    }),
    props: {
        coins: String,
        bonus: String,
        supplierName: String,
        planType: String,
        useCreditCardCountdown: Number,
        userNotification: Number,
    },
    methods: {
        ...mapActions('user', ['setUserCountdown']),
        numberWithPaddingZeros,
        convertNumberToBRLLocal(value) {
            const number = value.split(',');
            number[0] = 'R$ ' + number[0].split(/(?=(?:...)*$)/).join('.');
            return number.join(',');
        },
        onUseCreditCardCountdownEnd() {
            this.setUserCountdown();
        }
    }
};
</script>

<style lang="scss" scoped>
main {
    left: 110px;
}
li {
    list-style-type: none;
}

header {
    height: 53px;
}

.header-color {
    background-color: #ffffff;
    display: flex;
    height: 54px;
    line-height: 54px;
    box-shadow: 0px 3px 6px #00000029;
}

.brand-logo-supplier {
    display: flex;
    align-items: center;
    margin-left: 58px;
    cursor: pointer;
}

nav .supplier-data {
    right: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    height: 56px;
}

.bonus-info {
    align-items: flex-end;
    justify-content: center;
    position: relative;
    display: flex;
    padding-right: 25px;
    margin-right: 25px;
    flex-direction: column;
}

.bonus-info:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1px;
    height: 38px;
    background-color: #a5a5a588;
}

.countdown-title {
    text-align: end;
    color: #a5a5a5;
    font: normal normal normal 11px Open Sans;
}

.countdown-value {
    color: #62727b;
    font: normal normal bold 15px Open Sans;
}

.bonus-title {
    text-align: end;
    color: #a5a5a5;
    font: normal normal normal 11px Open Sans;
}

.bonus-value {
    color: #62727b;
    font: normal normal bold 15px Open Sans;
}

.coins-info {
    align-items: center;
    position: relative;
    display: flex;
    padding-right: 25px;
    margin-right: 25px;
}

.coins-info:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1px;
    height: 38px;
    background-color: #a5a5a588;
}

.coins-title {
    text-align: end;
    color: #a5a5a5;
    font: normal normal normal 11px Open Sans;
}

.coins-value {
    color: #62727b;
    font: normal normal bold 15px Open Sans;
}

.supplier-info {
    align-items: center;
    align-content: center;
    display: flex;
}

.plan-title {
    text-align: end;
    font: normal normal normal 11px Open Sans;
    color: #707070;
}

.supplier-title {
    text-align: left;
    color: #707070;
    font: normal normal bold 13px Open Sans;
    margin-bottom: 4px;
}

.btn-dropdown {
    position: relative;
    display: flex;
    margin-right: 92px;
    margin-left: 50px;
}

.btn-hat {
    font-size: 28px;
    background-color: #0173cd;
}

.btn-floating svg {
    line-height: 39px !important;
    font-size: 28px !important;
    position: relative;
    top: -2px;
}

.btn-hat:hover {
    background-color: #008fff;
}

.btn-hat:focus {
    background-color: #0173cd;
}

.dropdown-item {
    cursor: pointer;
    color: #707070;
    font-size: 13px;
    line-height: 40px;
}

.dropdown-item:last-child {
    margin-bottom: 18px;
}

.dropdown-item:hover {
    color: #5f5d5d;
    color: black;
}

.dropdown-content-supplier {
    margin-top: 58px;
    right: 0;
    position: absolute;
    text-align: left;
    width: 180px;
    background-color: #fff;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
    padding-left: 15px;
    margin-right: 93px;
    border-radius: 3px;
}

/*translate fade (top to down)*/
.translate-fade-down-enter-active,
.translate-fade-down-leave-active {
    transition: all 500ms;
    transition-timing-function: cubic-bezier(0.53, 2, 0.36, 0.85);
}

.translate-fade-down-enter,
.translate-fade-down-leave-active {
    opacity: 0;
}

.translate-fade-down-enter,
.translate-fade-down-leave-to {
    position: absolute;
}

.translate-fade-down-enter {
    transform: translateY(-10px);
}

.translate-fade-down-leave-active {
    transform: translateY(10px);
}

.supplier-data .link-menu {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    position: relative;
    text-decoration: none;
    text-decoration: none;
    font-size: 14px;
    color: #707070;
    font-weight: bold;
    margin-right: 25px;
    padding-right: 25px;
}

.supplier-data .link-menu::after {
    content: '';
    position: absolute;
    right: 0;
    width: 1px;
    height: 38px;
    background-color: #a5a5a588;
}

.supplier-data .link-menu:hover {
    cursor: pointer;
    color: #0173cd;
}

.notification-circle {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: red;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 999;
}

.notification-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}
.notification-count {
    background-color: red;
    display: flex;
    align-content: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    color: #fff;
    font-weight: bold;
    margin-right: 10px;
    line-height: 20px;
}
#new {
    position: relative;
}
#new::before {
content: "Novo";
    padding: 2px;
    background-color: red;
    position: absolute;
    top: 6px;
    right: 9px;
    font-size: 10px;
    color: #fff;
    width: auto;
    height: auto;
    line-height: 11px;
    border-radius: 4px;
    margin: 0px;
}
</style>
